import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";
const bqGetProgramSummary = async function(programId, startDate, endDate) {
    let summary = {
        numberOfRecords: {
            healthData: 0,
            sleep: 0,
            water: 0,
            workout: 0,
            food: 0
        },
        memberNumbers: {
            male: 0,
            female: 0,
        },
        totalSummary: {
            onsite: 0,
            preTest: 0,
            postTest: 0
        },
        totalBehaviors: {
            totalWorkoutMins: 0,
            steps: 0,
            totalWeightLoss: 0,
            avgBMI: 0,
        },
        communication: {
            coach: 0,
            member: 0
        },
        agesOfUsers: {
            categories: ['0-14', '15-39', '40-49', '50-59', '60+'],
            male: [],
            female: [],
            maxY: 0
        },
        chartWeight:{
          avgStartWeight: 0,
          avgEndWeight: 0
        },
        chartBMI:{
          avgStartBMI: 0,
          avgEndBMI: 0
        },
        chartPressure:{
          avgStartPressureLower: 0,
          avgEndPressureLower: 0,
          avgStartPressureUpper: 0,
          avgEndPressureUpper: 0,
        },
        chartLDL:{
          avgStartLDL: 0,
          avgEndLDL: 0
        },
        chartFBS:{
          avgStartFBS: 0,
          avgEndFBS: 0
        },
        userList: []
    };
    const app = firebase.app();
    const functions = getFunctions(app, 'asia-east2');
    const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');

    const queryList = {
        'groupMemberData': `
                            SELECT 
                                U.uid,
                                concat(U.firstname, ' ', U.lastname) name,
                                U.pictureUrl,
                                G.isPreTestCompletion,
                                G.isPostTestCompletion
                            FROM 
                                thaisook_view.program_members G
                                left join thaisook_view.users U
                                on G.uid = U.uid 
                            where 
                                G.programId = '${programId}'
        `,
        'weightData': `
                        SELECT 
                            HD.uid,
                            HD.date, 
                            HD.weight,
                            FIRST_VALUE(HD.weight) OVER(PARTITION BY HD.uid ORDER BY date) AS start_weight,
                            LAST_VALUE(HD.weight) OVER(PARTITION BY HD.uid ORDER BY date desc) AS end_weight,
                            ROW_NUMBER() OVER(PARTITION BY HD.uid ORDER BY date DESC) AS last_record
                        FROM 
                            thaisook_view.healthdata HD
                            join thaisook_view.program_members G
                            on G.uid = HD.uid 
                        where 
                            HD.weight is not null
                            and G.programId = '${programId}'
                            and date(HD.date) between '${startDate}' and '${endDate}'
                            order by HD.date
        `,
        'bmiData': `
                        SELECT 
                            HD.uid,
                            HD.date, 
                            HD.bmi,
                            FIRST_VALUE(HD.bmi) OVER(PARTITION BY HD.uid ORDER BY date) AS start_bmi,
                            LAST_VALUE(HD.bmi) OVER(PARTITION BY HD.uid ORDER BY date desc) AS end_bmi,
                            ROW_NUMBER() OVER(PARTITION BY HD.uid ORDER BY date DESC) AS last_record
                        FROM 
                            thaisook_view.healthdata HD
                            join thaisook_view.program_members G
                            on G.uid = HD.uid 
                        where 
                            HD.bmi is not null
                            and G.programId = '${programId}'
                            and date(HD.date) between '${startDate}' and '${endDate}'
                            order by HD.date
        `,
        'pressureUpperData': `
                        SELECT 
                            HD.uid,
                            HD.date, 
                            HD.pressureUpper,
                            FIRST_VALUE(HD.pressureUpper) OVER(PARTITION BY HD.uid ORDER BY date) AS start_pressureUpper,
                            LAST_VALUE(HD.pressureUpper) OVER(PARTITION BY HD.uid ORDER BY date desc) AS end_pressureUpper,
                            ROW_NUMBER() OVER(PARTITION BY HD.uid ORDER BY date DESC) AS last_record
                        FROM 
                            thaisook_view.healthdata HD
                            join thaisook_view.program_members G
                            on G.uid = HD.uid 
                        where 
                            HD.pressureUpper is not null
                            and G.programId = '${programId}'
                            and date(HD.date) between '${startDate}' and '${endDate}'
                            order by HD.date
        `,
        'pressureLowerData': `
                        SELECT 
                            HD.uid,
                            HD.date, 
                            HD.pressureLower,
                            FIRST_VALUE(HD.pressureLower) OVER(PARTITION BY HD.uid ORDER BY date) AS start_pressureLower,
                            LAST_VALUE(HD.pressureLower) OVER(PARTITION BY HD.uid ORDER BY date desc) AS end_pressureLower,
                            ROW_NUMBER() OVER(PARTITION BY HD.uid ORDER BY date DESC) AS last_record
                        FROM 
                            thaisook_view.healthdata HD
                            join thaisook_view.program_members G
                            on G.uid = HD.uid 
                        where 
                            HD.pressureLower is not null
                            and G.programId = '${programId}'
                            and date(HD.date) between '${startDate}' and '${endDate}'
                            order by HD.date
        `,
        'fbsData': `
                        SELECT 
                            HD.uid,
                            HD.date, 
                            HD.glucose,
                            FIRST_VALUE(HD.glucose) OVER(PARTITION BY HD.uid ORDER BY date) AS start_fbs,
                            LAST_VALUE(HD.glucose) OVER(PARTITION BY HD.uid ORDER BY date desc) AS end_fbs,
                            ROW_NUMBER() OVER(PARTITION BY HD.uid ORDER BY date DESC) AS last_record
                        FROM 
                            thaisook_view.healthdata HD
                            join thaisook_view.program_members G
                            on G.uid = HD.uid 
                        where 
                            HD.glucose is not null
                            and G.programId = '${programId}'
                            and date(HD.date) between '${startDate}' and '${endDate}'
                            order by HD.date
        `,
        'ldlData': `
                        SELECT 
                            HD.uid,
                            HD.date, 
                            HD.ldl,
                            FIRST_VALUE(HD.ldl) OVER(PARTITION BY HD.uid ORDER BY date) AS start_ldl,
                            LAST_VALUE(HD.ldl) OVER(PARTITION BY HD.uid ORDER BY date desc) AS end_ldl,
                            ROW_NUMBER() OVER(PARTITION BY HD.uid ORDER BY date DESC) AS last_record
                        FROM 
                            thaisook_view.healthdata HD
                            join thaisook_view.program_members G
                            on G.uid = HD.uid 
                        where 
                            HD.ldl is not null
                            and G.programId = '${programId}'
                            and date(HD.date) between '${startDate}' and '${endDate}'
                            order by HD.date
        `,
        'memberData': `
                        SELECT 
                            GM.uid, 
                            GM.name,
                            GM.pictureUrl,
                            IF (GM.isPreTestCompletion, 1, 0) as isPreTestCompletion,
                            IF (GM.isPostTestCompletion, 1, 0) as isPostTestCompletion,
                            WD.start_weight, 
                            WD.end_weight, 
                            BD.start_bmi, 
                            BD.end_bmi,
                            PLD.start_pressureLower,
                            PLD.end_pressureLower,
                            PUD.start_pressureUpper,
                            PUD.end_pressureUpper,
                            LD.start_ldl, 
                            LD.end_ldl,
                            FD.start_fbs,
                            FD.end_fbs
                        FROM 
                            groupMemberData GM
                            left join weightData WD 
                                on GM.uid = WD.uid and WD.last_record = 1
                            left join bmiData BD
                                on GM.uid = BD.uid and BD.last_record = 1
                            left join pressureLowerData PLD
                                on GM.uid = PLD.uid and PLD.last_record = 1
                            left join pressureUpperData PUD
                                on GM.uid = PUD.uid and PUD.last_record = 1
                            left join ldlData LD
                                on GM.uid = LD.uid and LD.last_record = 1
                            left join fbsData FD
                                on GM.uid = FD.uid and FD.last_record = 1
                        where GM.uid is not null
        `,
        'memberDataAVG': `
                        SELECT 
                            avg(start_weight) as start_weight_avg,  
                            avg(end_weight) as end_weight_avg,  
                            avg(start_bmi) as start_bmi_avg,  
                            avg(end_bmi) as end_bmi_avg,  
                            avg(start_pressureLower) as start_pressureLower_avg,  
                            avg(end_pressureLower) as end_pressureLower_avg,  
                            avg(start_pressureUpper) as start_pressureUpper_avg,  
                            avg(end_pressureUpper) as end_pressureUpper_avg,  
                            avg(start_ldl) as start_ldl_avg,  
                            avg(end_ldl) as end_ldl_avg,  
                            avg(start_fbs) as start_fbs_avg,  
                            avg(end_fbs) as end_fbs_avg,
                            avg(isPreTestCompletion) as isPreTestCompletion_avg,
                            avg(isPostTestCompletion) as isPostTestCompletion_avg
                        FROM 
                            userData
        `
    };

    const result = await Promise.all([

        //0: get member counting
        queryThaisookViewBigQuery({
            info: 'get member counting',
            query:  `
                SELECT 
                    count(case when gender='male' then 1 end) as male_cnt, 
                    count(case when gender='female' then 1 end) as female_cnt, 
                    count(1) as total_cnt 
                FROM 
                    thaisook_view.users as A, 
                    thaisook_view.program_members as B 
                WHERE 
                    A.uid = B.uid 
                    and B.programId='${programId}'
            `
        }), 

        //1: get age group
        queryThaisookViewBigQuery({
            info: 'get age group',
            query:  
            `WITH data as (
                SELECT 
                B.gender as sex,
                IF( B.birthdate is null, 0, 
                    DATETIME_DIFF(CURRENT_DATETIME, B.birthdate, YEAR )) as age
                FROM 
                bsp-kiosk.thaisook_view.program_members A, 
                bsp-kiosk.thaisook_view.users B 
                where 
                A.uid = B.uid
                and A.programId='${programId}' 
            )
            -- '0-14', '15-39', '40-49', '50-59', '60+'
            SELECT (CASE WHEN age < 15 then '0-14'
                        WHEN age < 40 then '15-39'
                        WHEN age < 50 then '40-49'
                        WHEN age < 60 THEN '50-59'
                        WHEN age >= 60 THEN '60+'
                    END) as agegrp, sex,
                    COUNT(*) as nt
            FROM data
            GROUP BY agegrp, sex
            ORDER BY sex, MIN(age);
            `
        }),

        //2: total weight loss
        queryThaisookViewBigQuery({
            info: 'get total weight loss',
            query: `
            with data as (
                ${queryList.weightData}
              )
              , data2 as (
                select * from data where last_record = 1
              )
              select 
                sum(start_weight - end_weight) as totalWeightLoss 
              from 
                data2
              where 
                end_weight < start_weight
            `
        }),

        //3: total workout mins
        queryThaisookViewBigQuery({
            info: 'get total workout mins',
            query: `
                SELECT 
                    sum(WO.totalWorkout) totalWorkoutMins
                FROM 
                    activity_view.workout WO
                    join thaisook_view.program_members G
                        on G.uid = WO.uid 
                where 
                    WO.totalWorkout is not null
                    and G.programId = '${programId}'
                    and date(WO.date) between '${startDate}' and '${endDate}'
            `
        }),

        //4: bmi avg
        queryThaisookViewBigQuery({
            info: 'get bmi avg',
            query: `
                with data as (
                    ${queryList.bmiData}
                )
                select avg(end_bmi) avgBMI from data where last_record = 1
            `
        }),

        //5: total serving
        queryThaisookViewBigQuery({
            info: 'get total serving',
            query: `
                SELECT 
                    sum(FO.serving) as totalPBWF
                FROM 
                    activity_view.food FO
                    join thaisook_view.program_members G
                    on G.uid = FO.uid 
                where 
                    FO.serving is not null
                    and G.programId = '${programId}'
                    and date(FO.date) between '${startDate}' and '${endDate}'
          
            `
        }),

        //6: get member list
        queryThaisookViewBigQuery({
            info: 'get member list',
            query: `
                with groupMemberData as (${queryList.groupMemberData}),
                weightData as (${queryList.weightData}),
                bmiData as (${queryList.bmiData}),
                pressureLowerData as (${queryList.pressureLowerData}),
                pressureUpperData as (${queryList.pressureUpperData}),
                ldlData as (${queryList.ldlData}),
                fbsData as (${queryList.fbsData})
                ${queryList.memberData}
            `
        }),

        //7: get group chart
        queryThaisookViewBigQuery({
            info: 'get group chart',
            query: `
                with groupMemberData as (${queryList.groupMemberData}),
                weightData as (${queryList.weightData}),
                bmiData as (${queryList.bmiData}),
                pressureLowerData as (${queryList.pressureLowerData}),
                pressureUpperData as (${queryList.pressureUpperData}),
                ldlData as (${queryList.ldlData}),
                fbsData as (${queryList.fbsData}),
                userData as (${queryList.memberData})
                ${queryList.memberDataAVG}
            `
        }),

        //8: get number of records
        queryThaisookViewBigQuery({
            info: 'get number of records',
            query:  
            `with dataHealthdata as (
                SELECT 
                    count(*) cnt,
                    'healthdata' title
                FROM 
                    thaisook_view.healthdata HD
                    join thaisook_view.program_members G
                    on G.uid = HD.uid 
                where 
                    G.programId = '${programId}'
                    and date(HD.date) between '${startDate}' and '${endDate}'
            ),
            dataSleep as (
                SELECT 
                    count(*) cnt,
                    'sleep' title
                FROM 
                    activity_view.sleep HD
                    join thaisook_view.program_members G
                    on G.uid = HD.uid 
                where 
                    G.programId = '${programId}'
                    and date(HD.date) between '${startDate}' and '${endDate}'
            ),
            dataWorkout as (
                SELECT 
                    count(*) cnt,
                    'workout' title
                FROM 
                    activity_view.workout HD
                    join thaisook_view.program_members G
                    on G.uid = HD.uid 
                where 
                    G.programId = '${programId}'
                    and date(HD.date) between '${startDate}' and '${endDate}'
            ),
            dataSteps as (
                SELECT 
                    count(*) cnt,
                    'steps' title
                FROM 
                    activity_view.steps HD
                    join thaisook_view.program_members G
                    on G.uid = HD.uid 
                where 
                    G.programId = '${programId}'
                    and date(HD.date) between '${startDate}' and '${endDate}'
            ),
            dataWater as (
                SELECT 
                    count(*) cnt,
                    'water' title
                FROM 
                    activity_view.water HD
                    join thaisook_view.program_members G
                    on G.uid = HD.uid 
                where 
                    G.programId = '${programId}'
                    and date(HD.date) between '${startDate}' and '${endDate}'
            ),
            dataFood as (
                SELECT 
                    count(*) cnt,
                    'food' title
                FROM 
                    activity_view.food HD
                    join thaisook_view.program_members G
                    on G.uid = HD.uid 
                where 
                    G.programId = '${programId}'
                    and date(HD.date) between '${startDate}' and '${endDate}'
            )
            select * from dataHealthdata
            union all 
            select * from dataSleep
            union all
            select * from dataWater
            union all
            select * from dataWorkout
            union all
            select * from dataSteps
            union all
            select * from dataFood;
            `
        }),

        //9: onsite count
        queryThaisookViewBigQuery({
            info: 'get member onsite',
            query:  `
                select sum(onsiteCount) onsiteCount from thaisook_view.program_members where programId='${programId}'
            `
        }), 

        //10: total steps
        queryThaisookViewBigQuery({
            info: 'get total steps',
            query: `
                SELECT 
                    sum(WO.steps) steps
                FROM 
                    activity_view.steps WO
                    join thaisook_view.program_members G
                        on G.uid = WO.uid 
                where 
                    WO.steps is not null
                    and G.programId = '${programId}'
                    and date(WO.date) between '${startDate}' and '${endDate}'
            `
        }), 

        //11: communication
        queryThaisookViewBigQuery({
            info: 'get communication',
            query: `
                with coachMessage as (
                    select 
                        count(1) cnt
                    from 
                        activity_view.chat WO 
                        join thaisook_view.program_members CC
                            on WO.messageTo = CC.uid and WO.groupId = CC.groupId
                    where 
                        CC.programId = '${programId}'
                        and date(WO.date) between '${startDate}' and '${endDate}'
                ),
                memberMessage as (
                    select 
                        count(1) cnt
                    from 
                        activity_view.chat WO 
                        join thaisook_view.program_members CC
                            on WO.messageFrom = CC.uid and WO.groupId = CC.groupId
                    where 
                        CC.programId = '${programId}'
                        and date(WO.date) between '${startDate}' and '${endDate}'
                )
                select cnt from coachMessage
                union all
                select cnt from memberMessage
            `
        })
    ]);

    let memberCount = 0;
    const memberNumberObj = JSON.parse(result[0].data);
    if( memberNumberObj.length ){
        summary.memberNumbers.male = memberNumberObj[0].male_cnt;
        summary.memberNumbers.female = memberNumberObj[0].female_cnt;
        memberCount = memberNumberObj[0].total_cnt;
    }

    const memberAgeOfUsersObj = JSON.parse(result[1].data);
    if( memberAgeOfUsersObj.length ){
        const memberAgeOfUsers = memberAgeOfUsersObj.reduce((tmp, doc) => {
            if( tmp[doc.agegrp] == undefined ){
                tmp[doc.agegrp] = {
                    male: 0,
                    female: 0,
                    total: 0
                };
            }
            tmp[doc.agegrp][doc.sex] = doc.nt;
            tmp[doc.agegrp]['total'] = tmp[doc.agegrp]['total'] + doc.nt; 
            return tmp;
        }, {});

        for (let i = 0; i < summary.agesOfUsers.categories.length; i++) {
            const group = summary.agesOfUsers.categories[i];
            summary.agesOfUsers.male.push(memberAgeOfUsers[group] == undefined ? 0: memberAgeOfUsers[group]['male']);
            summary.agesOfUsers.female.push(memberAgeOfUsers[group] == undefined ? 0: memberAgeOfUsers[group]['female']);
            
            if( memberAgeOfUsers[group] != undefined) {
                if( summary.agesOfUsers.maxY < memberAgeOfUsers[group]['total'] ){
                    summary.agesOfUsers.maxY = memberAgeOfUsers[group]['total'];
                }
            }
        }
    }

    const summaryInfoWeightLoss = JSON.parse(result[2].data);
    if( summaryInfoWeightLoss.length ){
        summary.totalBehaviors.totalWeightLoss = summaryInfoWeightLoss[0].totalWeightLoss / memberCount;
    }

    const summaryInfoWorkoutTotal = JSON.parse(result[3].data);
    if( summaryInfoWorkoutTotal.length ){
        summary.totalBehaviors.totalWorkoutMins = summaryInfoWorkoutTotal[0].totalWorkoutMins / memberCount;
    }    
    
    const summaryInfoStepTotal = JSON.parse(result[10].data);
    if( summaryInfoStepTotal.length ){
        summary.totalBehaviors.steps = summaryInfoStepTotal[0].steps / memberCount;
    }

    const summaryInfoAvgBMI = JSON.parse(result[4].data);
    if( summaryInfoAvgBMI.length ){
        summary.totalBehaviors.avgBMI = summaryInfoAvgBMI[0].avgBMI;
    }

    // const summaryInfoTotalPBWF = JSON.parse(result[5].data);
    // if( summaryInfoTotalPBWF.length ){
    //     summary.totalBehaviors.totalPBWF = parseFloat(summaryInfoTotalPBWF[0].totalPBWF / memberCount).toFixed(2);
    // }

    const onsiteCountObj = JSON.parse(result[9].data);
    if( onsiteCountObj.length ){
        summary.totalSummary.onsite = onsiteCountObj[0].onsiteCount / memberCount;
    }

    const groupMemberData = JSON.parse(result[6].data);
    if( groupMemberData.length ){
        summary.userList = groupMemberData;
    }
    const groupMemberChart = JSON.parse(result[7].data);
    if( groupMemberChart.length ){
        summary.chartWeight.avgStartWeight = groupMemberChart[0].start_weight_avg;
        summary.chartWeight.avgEndWeight = groupMemberChart[0].end_weight_avg;
        summary.chartBMI.avgStartBMI = groupMemberChart[0].start_bmi_avg;
        summary.chartBMI.avgEndBMI = groupMemberChart[0].end_bmi_avg;
        summary.chartPressure.avgStartPressureUpper = groupMemberChart[0].start_pressureUpper_avg;
        summary.chartPressure.avgEndPressureUpper = groupMemberChart[0].end_pressureUpper_avg;
        summary.chartPressure.avgStartPressureLower = groupMemberChart[0].start_pressureLower_avg;
        summary.chartPressure.avgEndPressureLower = groupMemberChart[0].end_pressureLower_avg;
        summary.chartLDL.avgStartLDL = groupMemberChart[0].start_ldl_avg;
        summary.chartLDL.avgEndLDL = groupMemberChart[0].end_ldl_avg;
        summary.chartFBS.avgStartFBS = groupMemberChart[0].start_fbs_avg;
        summary.chartFBS.avgEndFBS = groupMemberChart[0].end_fbs_avg;
        summary.totalSummary.preTest = (groupMemberChart[0].isPreTestCompletion_avg * 100);
        summary.totalSummary.postTest = (groupMemberChart[0].isPostTestCompletion_avg * 100);
    }

    const numberOfRecordsObj = JSON.parse(result[8].data);
    if( numberOfRecordsObj.length ){
        for (let i = 0; i < numberOfRecordsObj.length; i++) {
            const item = numberOfRecordsObj[i];
            summary.numberOfRecords[item.title] = numberOfRecordsObj[i].cnt;    
        }
    }

    const communicationObj = JSON.parse(result[11].data);
    if( communicationObj.length ){
        summary.communication['coach'] = communicationObj[0].cnt;
        summary.communication['member'] = communicationObj[1].cnt;
    }
    
    return summary;
};
export default bqGetProgramSummary;
